"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strings = {
    address: {
        address: "Address",
        address2: "Suite / Apt",
        city: "City",
        state: "State",
        zipCode: "ZIP Code",
        addressRequired: "Address (*)",
        cityRequired: "City (*)",
        zipCodeRequired: "ZIP Code (*)",
        zipcodeValidationError: "Please enter the 5 digit zip code",
        states: ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI",
            "ID", "IL", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO",
            "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA",
            "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
            "AS", "DC", "FM", "GU", "MP", "PW", "PR", "VI"],
    },
    back: "Back",
    chart: {
        noData: "No data to display",
    },
    childForm: {
        birthDate: "Birth or Expected Date",
        buttonAdd: "Add Child",
        buttonSave: "Save Changes",
        buttonSeat: "View Enrolled Seat",
        childTitle: "Child Details",
        female: "Female",
        firstName: "First Name",
        gender: "Gender",
        lastName: "Last Name",
        male: "Male",
        noGender: "Not Specified",
        noName: "Name not chosen",
        otherGender: "Other",
        trying: "Trying (no expected date)",
        useParent1Address: "Use same address as parent / guardian 1",
        useParent2Address: "Use same address as parent / guardian 2",
    },
    chooseDate: {
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        day: "Day",
        month: "Month",
        year: "Year",
    },
    chooseFamily: {
        birthDate: "Birth or Expected Date",
        canText: "OK to text updates",
        childBirthday: "Child birth date",
        childFirstName: "Child First Name",
        childLastName: "Child Last Name",
        email: "E-mail",
        parentFirstName: "Parent / Guardian First Name",
        parentLastName: "Parent / Guardian Last Name",
        phoneNumber: "Mobile number",
        trying: "No child expected yet",
    },
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    enterNavigator: {
        alertTitle: "Warning",
        buttonVerify: "Verify Agent",
        errorConsent: "Please check the box to indicate you have the parent / guardian consent to fill out this form on their behalf",
        errorUser: "Sorry, we don't have this email on file to manage other parent / guardians. For more assistance, please reach out to support@legup.care",
        title: "Filling out this form on behalf of a parent / guardian?",
        instructions: "To fill out this form on behalf of a parent / guardian, you must be registered as an agent with LegUp. Please enter your e-mail address to verify that you are registered with LegUp.",
        labelEmail: "Your email address",
        labelConsent: "By checking this box, you acknowledge you have consent to act on behalf of this parent / guardian",
    },
    errorMessages: {
        emailValidationError: "Invalid e-mail address",
    },
    next: "Next",
    no: "No",
    ok: "OK",
    phoneNumbers: {
        canText: "OK to text updates",
        errorMessageSingle: "Please enter a phone number",
        errorMessageMultiple: "Please enter at least one phone number",
        errorMessagePrimary: "Please mark a phone number as primary",
        labelHome: "Home phone number",
        labelWork: "Work phone number",
        labelCell: "Mobile phone number",
        labelPhone: "Phone number",
        labelPrimary: "Primary",
        sms: "SMS",
        landline: "Landline",
    },
    requestTour: {
        comments: "Additional comments",
        dayTime: {
            "Early Morning": "0:9",
            Morning: "9:12",
            Afternoon: "12:16",
            Evening: "16:24",
        },
        inPerson: "We offer in person tours for this program. {Times}",
        instructions: "Select your preferred day(s) and time for a tour. We will pass this information to {Center} and they will confirm a tour with you as soon as possible.",
        labelEmail: "E-mail:",
        labelName: "Your name:",
        message: "We would like to tour {days} in the {times}",
        preferredDate: "Enter your preferred enrollment month",
        scheduleAgeGroup: "We offer tours for {AgeGroup} families on {Schedule}.",
        scheduleNoAgeGroups: "We offer tours on {Schedule}.",
        scheduleWithAgeGroups: "We offer tours to all families on {Schedule}. {AgeGroups}",
        selectDay: "Select a day:",
        selectTime: "Select a time:",
        subComments: "If you would like to tour after the next week, please indicate your preferred date(s) in the comments below",
        submit: "submit",
        title: "Request a tour",
        virtual: "We offer online tours for this program. {Times} You will be sent video conference instructions after your tour is confirmed.",
        weekdayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    },
    requiredFields: {
        message: "Please fill out required fields in red",
        title: "Required Fields",
    },
    selectTour: {
        noTimes: "No times available",
        tip: "This is a {Duration} minute tour",
        tipVirtual: "This is an online tour lasting {Duration} minutes",
        tipInPerson: "This is an in-person tour lasting {Duration} minutes",
    },
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    subsidies: {
        couponSubsidyLabel: "Is this coupon only for those on a subsidy program?",
        couponNo: "No. It's available for all families.",
        couponYes: "Yes. It's available for only those families on the following subsidy programs:",
        subsidyLabel: "Will you have subsidized child care?",
    },
    yes: "Yes",
    basics: {
        curriculum: "This provider's education philosophy",
        language: "Languages spoken",
        languagetaught: "Languages taught",
        abilities: "This provider supports different abilities",
        wheelchair: "This program is wheelchair accessible",
        verified: "Vetted for safety",
        day: "Days programs are offered",
        time: "Hours of operation",
        schedule: "Class schedule",
        center: "Where care is offered, either in a provider's home or a center",
        payment: "Average tuition for this program",
        child: "Age range for children that this provider cares for",
        subsidy: "Subsidies this provider accepts to offset the cost of care",
    }
};
exports.default = strings;
